import { EventsActions } from 'store/actions';
import { EventsSelectors } from 'store/selectors';
import withRouteValidation from 'hocs/withRouteValidation';
import withOrganizationEvents from 'components/organization/withOrganizationEvents';

export default withRouteValidation(
  withOrganizationEvents(
    'organization.upcomingEvents',
    EventsActions.getUpcomingEvents,
    EventsSelectors.upcomingEventsState,
    EventsSelectors.upcomingEventsPagination,
    'session_date',
  ),
);
